import { render, staticRenderFns } from "./OrgUnitSelect.vue?vue&type=template&id=6bd3ed5b&"
import script from "./OrgUnitSelect.vue?vue&type=script&lang=js&"
export * from "./OrgUnitSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports